import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
        data:{}
    }
}
//types
const OBTENER_POLIGONO_KML_EXITO= 'OBTENER_POLIGONO_KML_EXITO'
const AGREGAR_POLIGONO_KML_EXITO= 'AGREGAR_POLIGONO_KML_EXITO'

const ACTUALIZAR_POLIGONO_KML_EXITO= 'ACTUALIZAR_POLIGONO_KML_EXITO'


export const obtenerAllPoligonoKml = createAsyncThunk(
    OBTENER_POLIGONO_KML_EXITO,
    async () => {
        try {
            const fullUrl = host + `PoligonoKml/obtenerAllPoligonoKml`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarPoligonoKml = createAsyncThunk(
    AGREGAR_POLIGONO_KML_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `PoligonoKml/agregarPoligonoKml`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarPoligonoKml = createAsyncThunk(
    ACTUALIZAR_POLIGONO_KML_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `PoligonoKml/actualizarPoligonoKml`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



export const poligonoKmlSlice = createSlice({
    name: 'poligonoKmlSlice',
    initialState: dataInicial,
    reducers: {
       
    },
    extraReducers: {
      
        [obtenerAllPoligonoKml.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
        [agregarPoligonoKml.fulfilled]: (state, { payload }) => {
         
        },

        [actualizarPoligonoKml.fulfilled]: (state, { payload }) => {
       
        },
    },
})

export const {
} = poligonoKmlSlice.actions
export const PoligonoKmlReducerUsuarioAgricola = poligonoKmlSlice.reducer
